





















import { Component, Inject, Mixins, Watch } from 'vue-property-decorator';
import { AxiosInstance } from 'axios';
import { get } from 'lodash';
import TransitionGroup from '@/components/transition/Group.vue';
import { Breadcrumbs as BreadcrumbsLayout } from '@/components/layout';
import { AppHeading } from '@/uikit';
import breadcrumbsMixin from './mixins/breadcrumbs-mixin';
import ItemSingle from '@/components/parts/catalog/list/item/single';
import { VacanciesCard } from '@/components/parts/vacancies/card';
import { ListPageLayout } from '@/uikit';
import { ListLayout } from '@/components/parts/listlayout';
import { ModuleCard } from '@/components/parts/modules';
import { ProfessionListCard } from '@/components/parts/professions';
import { CompetenceCard } from '@/components/parts/competences/card/';
import { Spinner as LoadingSpinner } from '@/components/spinners';
import { RouteParams, GlobalItems } from './types';
import {
  eventsService,
  modulesService,
  competencesService,
  professionsService,
  activitiesService,
  organizationsService,
  vacanciesService,
} from '@/services';

@Component({
  components: {
    BreadcrumbsLayout,
    ListPageLayout,
    ListLayout,
    AppHeading,
    ItemSingle,
    LoadingSpinner,
    ModuleCard,
    ProfessionListCard,
    CompetenceCard,
    TransitionGroup,
    VacanciesCard,
  },
})
export default class GlobalSearchList extends Mixins(breadcrumbsMixin) {
  @Inject() $api: AxiosInstance;

  globalItems: Array<GlobalItems> = [];
  isLoading = true;
  errorCounter = 6;

  get isError() {
    const { globalItems, errorCounter } = this;
    return !globalItems.length && !errorCounter;
  }

  get params(): RouteParams {
    const route = this.$route;
    return {
      page: 1,
      limit: 1000,
      ...route.query,
      ...route.params,
    };
  }

  get isTermExist(): boolean {
    return get(this.$route, 'query.term', '') ? true : false;
  }

  @Watch('$route.query.term')
  isRouteChange() {
    this.globalItems = [];
    this.errorCounter = 6;
    this.init();
  }

  @Watch('errorCounter')
  isErrorCounterTick(val: number) {
    if (!val) {
      this.stopLoading();
    }
  }

  mounted() {
    this.init();
  }

  async init() {
    if (!this.isTermExist) return;

    this.isLoading = true;

    await this.loadEvents();
    await this.loadEventsModules();
    await this.loadCompetences();
    await this.loadProfessions();
    await this.loadActivities();
    await this.loadOrganisationListData();
    await this.loadVacanciesListData();

    this.stopLoading();
  }

  async loadEvents() {
    const { $api, params } = this;
    try {
      const { data } = await eventsService($api).getEvents(params);
      if (data.length) {
        this.globalItems.push({
          name: 'Программы',
          component: 'ItemSingle',
          items: data,
        });
        this.stopLoading();
      }
    } catch (err) {
      console.error(err.response.data);
      this.errorCounter--;
    }
  }

  async loadEventsModules() {
    const { $api, params } = this;
    try {
      const { data } = await modulesService($api).getModules(params);
      if (data.length) {
        this.globalItems.push({
          name: 'Модули',
          component: 'ModuleCard',
          items: data,
        });
        this.stopLoading();
      }
    } catch (err) {
      console.error(err.response.data);
      this.errorCounter--;
    }
  }

  async loadCompetences() {
    const { $api, params } = this;
    try {
      const { data } = await competencesService($api).getCompetences(params);
      if (data.length) {
        this.globalItems.push({
          name: 'Компетенции',
          component: 'CompetenceCard',
          items: data,
        });
        this.stopLoading();
      }
    } catch (err) {
      console.error(err.response.data);
      this.errorCounter--;
    }
  }

  async loadProfessions() {
    const { $api, params } = this;
    try {
      const { data } = await professionsService($api).getProfessions(params);
      if (data.length) {
        this.globalItems.push({
          name: 'Профессии',
          component: 'ProfessionListCard',
          items: data,
        });
        this.stopLoading();
      }
    } catch (err) {
      console.error(err.response.data);
      this.errorCounter--;
    }
  }

  async loadActivities() {
    const { $api, params } = this;
    try {
      const { data } = await activitiesService($api).getActivities(params);
      if (data.length) {
        this.globalItems.push({
          name: 'Мероприятия',
          component: 'ItemSingle',
          items: data,
        });
        this.stopLoading();
      }
    } catch (err) {
      console.error(err.response.data);
      this.errorCounter--;
    }
  }

  async loadOrganisationListData() {
    const { $api, params } = this;
    let newParams: RouteParams = params;
    newParams = {
      ...newParams,
      organization: get(params, 'term', ''),
    };
    delete newParams.term;
    try {
      const { data } = await organizationsService($api).getOrganizationList(
        newParams
      );
      if (data.length) {
        this.globalItems.push({
          name: 'Организации',
          component: 'ItemSingle',
          items: data,
        });
        this.stopLoading();
      }
    } catch (err) {
      console.error(err.response.data);
      this.errorCounter--;
    }
  }

  async loadVacanciesListData() {
    const { $api, params } = this;
    let newParams: RouteParams = params;
    newParams = {
      ...newParams,
      vacancy_name: get(params, 'term', ''),
    };
    delete newParams.term;
    try {
      const { data } = await vacanciesService($api).getVacancies(newParams);
      if (data.length) {
        this.globalItems.push({
          name: 'Вакансии',
          component: 'VacanciesCard',
          items: data,
        });
        this.stopLoading();
      }
    } catch (err) {
      console.error(err.response.data);
      this.errorCounter--;
    }
  }

  stopLoading() {
    if (this.isLoading) this.isLoading = false;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/global-search/GlobalSearch.vue